module.exports = __webpack_public_path__ + "static/img/tips.7cc3fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car/tips.png
// module id = WP85
// module chunks = 1